export default {
  put({ data }) {
    return [200, {}]
  },
}
